export const getReqNote = (unformattedNote) => {
    if (!unformattedNote) return null;
    if (unformattedNote.includes("IBUY REQUISITION:")) {
        const noteArray = unformattedNote.split(" ");
        return noteArray.slice(3).join(" ");
    }
    return unformattedNote;
};
